import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

@Component({
  selector: "app-crypto-page",
  templateUrl: "./crypto-page.component.html",
  styleUrls: ["./crypto-page.component.scss"],
  standalone: false,
})
export class CryptoPageComponent implements OnInit {
  fullLayout: boolean = false;
  routeSubscription: Subscription;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.routeSubscription = this.route.url.subscribe(() => {
      this.updateLayoutState();
    });
  }

  updateLayoutState() {
    const data = this.route.snapshot.data;
    this.fullLayout = data.fullLayout;
  }
}
